import { ETime, HistoricOption } from './chart.component';

export const getToShortMonthYear = (isoDate) => {
    const date = new Date(isoDate);
    date.setDate(1);
    date.setMonth(date.getMonth() + 1);

    const monthYear = new Intl.DateTimeFormat('pt-BR', { month: 'short', year: '2-digit' })
    .format(date)
    .replace('.', '')
    .replace(' ', '/').replace('de ', '');
    
    const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

    return formattedMonth;
};

export const mapToChartContract = (historic: HistoricOption[], time: ETime) => {
    return historic?.slice(-time).map((h) => ({ name: getToShortMonthYear(h?.ref_month), uv: h?.last_price }));
}
